export type Theme = {
  slug: string;
  name: string;
  punch: string;
  text: string;
  image: string;
};

export const THEMES: Theme[] = [
  {
    slug: "co2",
    name: "Soirée CO₂",
    punch: "Effet stadium garanti",
    text: "Canon CO₂ professionnel pour des effets jets de fumée glaciale à -78°C. Idéal sur les drops, l'arrivée des mariés ou l'apothéose de fin de soirée.",
    image: "/__l5e/assets-v1/dcf79672-aabe-45d0-9d20-ef4bf55d1ae5/soiree-co2.webp",
  },
  {
    slug: "confettis",
    name: "Soirée Confettis",
    punch: "Pluie de couleurs sur le dancefloor",
    text: "Canon à confettis biodégradables, déclenché en synchro avec le mix. Effet wow immédiat, parfait pour les photos.",
    image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=900&q=72&auto=format&fit=crop",
  },
  {
    slug: "fluo",
    name: "Soirée Fluo",
    punch: "Black lights & néons",
    text: "Lumière noire UV, peintures et accessoires fluo offerts à vos invités. Une ambiance électrique pour les soirées étudiantes ou anniversaires fun.",
    image: "/__l5e/assets-v1/a3f88b97-c8ab-479a-a350-b215a52e1359/fluo_party.webp",
  },
  {
    slug: "karaoke",
    name: "Soirée Karaoké",
    punch: "Tout le monde au micro",
    text: "Catalogue de 50 000+ titres FR/EN, 2 micros HF, écran de paroles. Animation karaoké professionnelle pour vos soirées entre amis, EVJF/EVG, anniversaires.",
    image: "/__l5e/assets-v1/90220575-2de5-484d-a3f6-664ffe11ad3b/soiree-karaoke.webp",
  },
  {
    slug: "tempete-de-bulles",
    name: "Tempête de Bulles",
    punch: "Magie féerique",
    text: "Machine à bulles XXL projetant des milliers de bulles sur la piste. Effet poétique, particulièrement réussi pour les mariages et baptêmes.",
    image: "/__l5e/assets-v1/5446def2-5e70-4d3f-8821-bb95fd169dab/tempete-bulles.webp",
  },
  {
    slug: "tempete-de-neige",
    name: "Tempête de Neige",
    punch: "Wonderland instantané",
    text: "Machine à neige artificielle, idéale pour les mariages d'hiver, soirées thématiques nordiques ou Noël. Effet flocons sur toute la piste.",
    image: "/__l5e/assets-v1/9e6c73e9-e369-445d-b38a-8b88580c4687/tempete-de-neige.webp",
  },
  {
    slug: "mousse",
    name: "Soirée Mousse",
    punch: "Été inoubliable",
    text: "Canon à mousse hypoallergénique pour soirées d'été. Très demandé pour les campings, plages privées, EVJF en villa.",
    image: "/__l5e/assets-v1/fcc60913-f7d3-4a98-890b-ca97a0e34ab1/soiree-mousse.webp",
  },
];
